import React from 'react';
import Spinner from 'react-spinkit';
import classNames from 'classnames';
import ButtonBorder from './ButtonBorder';
import Button from './Button';

class PendingButton extends React.Component {
  render() {
    const { pending, children, view = 'border', ...rest } = this.props;
    const buttonClasses = classNames({ pending });

    const Component = view === 'border' ? ButtonBorder : Button;

    return (
      <Component className={buttonClasses} {...rest}>
        {pending ? (
          <Spinner name="ball-clip-rotate" color="white" fadeIn="quarter" />
        ) : (
          children
        )}
      </Component>
    );
  }
}

export default PendingButton;



// WEBPACK FOOTER //
// ./app/components/Button/PendingButton.jsx